import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const SearchServicesMaster = withSuspense(lazy(() => import('./services-master-search')));
export default SearchServicesMaster;
